import React from 'react';
import { AreaChart as RechartsAreaChart, Area, XAxis, YAxis, ResponsiveContainer } from 'recharts';
import styles from './AreaChart.module.css';
import Skeleton from '../Skeleton/Skeleton';
import Flex from '../Flex/Flex';

type DataPoint = {
    date: string;
    value: number;
};

type AreaChartProps = {
    data?: DataPoint[];
    title?: string;
    currentValue?: number;
    color?: string;
    valueFormatter?: (value: number) => string;
    height?: number;
    className?: string;
    patternOpacity?: number;
    strokeWidth?: number;
    hideAxes?: boolean;
    yAxisDomainOffset?: number;
    dataKey?: string;
    isLoading?: boolean;
};

const AreaChart = ({
   data = [],
   title = 'Chart',
   currentValue,
   color = '#7C3AED',
   valueFormatter = (value: number) => `${value}%`,
   height = 60,
   className = '',
   patternOpacity = 0.8,
   strokeWidth = 2,
   hideAxes = true,
   yAxisDomainOffset = 0,
   dataKey='value',
   isLoading = false,
}: AreaChartProps) => {
    const patternId = React.useId();

    if (isLoading) {
        return (
            <div className={`${styles.loadingContainer}`}>
                <Flex direction='column' gap={4} style={{height: `100%`}}>
                    <Skeleton width='50%' height={height} />
                    <Skeleton width='100%' height={"100%"} />
                </Flex>
            </div>
        );
    }

    return (
        <div className={`${styles.container} ${className}`}>
            <div className={styles.title}>
                {title}
            </div>

            {currentValue !== undefined && (
                <div className={styles.value}>
                    {valueFormatter(currentValue)}
                </div>
            )}

            <div
                className={styles.chartContainer}
                style={{ height: `${height}px` }}
            >
                <ResponsiveContainer width="100%" height="100%">
                    <RechartsAreaChart
                        data={data}
                    >
                        <defs>
                            <pattern
                                id={patternId}
                                patternUnits="userSpaceOnUse"
                                width="4"
                                height="4"
                            >
                                <line
                                    x1="0"
                                    y1="0"
                                    x2="0"
                                    y2="4"
                                    stroke={color}
                                    strokeWidth="1"
                                    strokeOpacity={patternOpacity}
                                />
                            </pattern>
                        </defs>
                        <XAxis
                            dataKey="date"
                            axisLine={false}
                            tickLine={false}
                            hide={hideAxes}
                        />

                        <YAxis
                            hide={hideAxes}
                            // domain={[
                            //     `dataMin - ${yAxisDomainOffset}`,
                            //     `dataMax + ${yAxisDomainOffset}`
                            // ]}
                        />

                        <Area
                            type="monotone"
                            dataKey={dataKey}
                            stroke={color}
                            strokeWidth={strokeWidth}
                            fill={`url(#${patternId})`}
                            fillOpacity={1}
                            dot={false}
                        />
                    </RechartsAreaChart>
                </ResponsiveContainer>
            </div>
        </div>
    );
};

export default AreaChart;